import React from "react";

import Icon from "src/components/icon";

type NumericStepperProps = {
    min: number;
    max: number;
    
    layout: "boxed" | "rounded" | "default";
    
    value: number;
    onChange: (value: number) => void;

    textColor?: string;
    highlightedColor?: string;
}

export default class NumericStepper extends React.Component<NumericStepperProps> {

    static defaultProps: Partial<NumericStepperProps> = {
        layout: "boxed",
    }

    getButtonStyles(): string {
        const layout = this.props.layout;
        if (layout === "boxed") return "rounded-lg text-[color:var(--highlightedColor)] flex justify-center items-center bg-[#f4f4f9] w-8 h-8";
        if (layout === "rounded") return "rounded-full border border-[#EAEAF2] text-[color:var(--highlightedColor)] flex justify-center items-center w-8 h-8";
        return "";
    }

    get style(): React.CSSProperties {
        const styles: Record<string, any> = {};
        if (this.props.textColor) styles['--text-color'] = this.props.textColor;
        if (this.props.highlightedColor) styles['--highlightedColor'] = this.props.highlightedColor;
        return styles as React.CSSProperties;
    }

    render() {
        const { onChange, value, min, max } = this.props;

        const styles = this.getButtonStyles();

        return (
            <div className="flex gap-1 items-center generalTextBold" style={this.style}>
                <button
                    disabled={value === min}
                    onClick={() => onChange(value - 1)}
                    className={styles + ` ${value === min ? 'grayscale opacity-50' : ''}`}
                >
                    <Icon icon="Minor" className="w-4 h-4 text-[color:var(--highlightedColor)]" />
                </button>
                <div className="searchWidgetNumber min-w-[16px] flex justify-center text-[color:var(--text-color)]">
                    {value}
                </div>
                <button
                    disabled={value === max}
                    onClick={() => onChange(value + 1)}
                    className={styles + ` ${value === max ? 'grayscale opacity-50' : ''}`}
                >
                    <Icon icon="Plus" className="w-4 h-4 text-[color:var(--highlightedColor)]" />
                </button>
            </div>
        );
    }
}
